import { $ } from 'src/shared/js/utils/dom';
const searchWrapper = $('.searchbar:not(.searchbar--large');

if (searchWrapper) {
  const submitForm = () => {
    const form = searchWrapper;
    const baseUrl = window.location.origin;
    const searchUrl = form.getAttribute('data-url-format');
    const inputValue = $('input', searchWrapper).value;
    const searchURL = baseUrl + searchUrl + encodeURIComponent(inputValue);
    window.location = searchURL;
  };

  const submitButton = $('.searchbar__button', searchWrapper);

  submitButton.addEventListener('click', event => {
    event.preventDefault();
    submitForm();
  });

  submitButton.addEventListener('keyup', event => {
    if (event.keyCode === 13) {
      event.preventDefault();
      submitForm();
    }
  });
}
